import { AiOutlineArrowLeft } from "react-icons/ai";
import CustomSvg from "../components/svgs/CustomSvg";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useGames } from "../utils/hooks";
import { postRequest } from "../components/apiRequests/requestApi";
import { toast } from "react-toastify";

const CreateHostedGame = () => {
  const [registrationDate, setRegistrationDate] = useState("");
  const [registrationTime, setRegistrationTime] = useState("");
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endDate, setEndDate] = useState("");
  const [endTime, setEndTime] = useState("");
  const [winners, setWinners] = useState("");
  const [tournamentName, setTournamentName] = useState("");
  const { games, getGames } = useGames();
  const [tournamentId, setTournamentId] = useState("");
  const { gameId } = useParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getGames();
  }, []);

  const navigate = useNavigate();
  const matchingGame = games.find(
    (game) => game.id?.toLowerCase() === gameId?.toLowerCase()
  );

  const gameIdNo = matchingGame?._id;

  const toISOString = (date, time) => {
    const dateTimeString = `${date}T${time}`;
    return new Date(dateTimeString).toISOString();
  };

  const handleSubmit = async () => {
    setLoading(true);
    const payload = {
      gameId: gameIdNo,
      registrationDeadline: toISOString(registrationDate, registrationTime),
      startDate: toISOString(startDate, startTime),
      endDate: toISOString(endDate, endTime),
      noOfWinners: parseInt(winners, 10),
      name: tournamentName,
    };

    try {
      const response = await postRequest({
        url: "/celebrity/tournaments",
        data: payload,
      });

      if (response?.data?._id) {
        const newTournamentId = response.data._id;
        setTournamentId(newTournamentId);
        toast.success("Tournament created successfully!");
        navigate(`/game/${winners}/${gameIdNo}/${newTournamentId}/winnings`);
      } else {
        toast.error("There was an error creating the tournament.");
        // console.error("There was an error creating a tournament");
      }
    } catch (error) {
      toast.error(error.message);
      // console.error("Submission failed:", error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#130828] h-screen flex flex-col  overflow-hidden">
      {/* Header */}
      <div className="relative flex items-center justify-center py-6 px-3 flex-shrink-0">
        <div className="absolute left-3">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-white"
          >
            <CustomSvg name="arrow-left" width={20} height={20} color="#fff" />
            <AiOutlineArrowLeft size={24} />
          </button>
        </div>
        <h2 className="text-xl font-bold bg-gradient-to-r from-[#C6BCFF] to-[#3F9217] bg-clip-text text-transparent text-center">
          Host Game
        </h2>
      </div>

      {/* Form Section */}
      <div className="flex-1 overflow-auto flex flex-col gap-4 max-w-md w-full mx-auto px-5 py-2">
        <label className="text-white font-semibold" htmlFor="tournamentName">
          Tournament Name
        </label>
        <input
          type="text"
          id="tournamentName"
          value={tournamentName}
          onChange={(e) => setTournamentName(e.target.value)}
          min={1}
          className="py-1 px-4 rounded-2xl w-full bg-white bg-opacity-10 text-white  placeholder-white placeholder-opacity-50"
          placeholder="Enter tournament name"
        />

        <label className="text-white font-semibold" htmlFor="registrationDate">
          Registration Deadline
        </label>
        <div className="flex flex-col gap-2">
          <input
            type="date"
            id="registrationDate"
            value={registrationDate}
            onChange={(e) => setRegistrationDate(e.target.value)}
            placeholder="Select registration date"
          className="py-1 px-4 rounded-2xl w-full bg-white bg-opacity-10 text-white  placeholder-white placeholder-opacity-50"
          />
          <input
            type="time"
            id="registrationTime"
            value={registrationTime}
            onChange={(e) => setRegistrationTime(e.target.value)}
          className="py-1 px-4 rounded-2xl w-full bg-white bg-opacity-10 text-white  placeholder-white placeholder-opacity-50"
          />
        </div>

        <label className="text-white font-semibold" htmlFor="startDate">
          Tournament Start
        </label>
        <div className="flex flex-col gap-2">
          <input
            type="date"
            id="startDate"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          className="py-1 px-4 rounded-2xl w-full bg-white bg-opacity-10 text-white  placeholder-white placeholder-opacity-50"
          />
          <input
            type="time"
            id="startTime"
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
          className="py-1 px-4 rounded-2xl w-full bg-white bg-opacity-10 text-white  placeholder-white placeholder-opacity-50"
          />
        </div>

        <label className="text-white font-semibold" htmlFor="endDate">
          Tournament End
        </label>
        <div className="flex flex-col gap-2">
          <input
            type="date"
            id="endDate"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          className="py-1 px-4 rounded-2xl w-full bg-white bg-opacity-10 text-white  placeholder-white placeholder-opacity-50"
          />
          <input
            type="time"
            id="endTime"
            value={endTime}
            onChange={(e) => setEndTime(e.target.value)}
          className="py-1 px-4 rounded-2xl w-full bg-white bg-opacity-10 text-white  placeholder-white placeholder-opacity-50"
          />
        </div>

        <label className="text-white font-semibold" htmlFor="winners">
          Number of Winners
        </label>
        <input
          type="number"
          id="winners"
          value={winners}
          onChange={(e) => setWinners(e.target.value)}
          min={1}
          className="py-1 px-4 rounded-2xl w-full bg-white bg-opacity-10 text-white  placeholder-white placeholder-opacity-50"
          placeholder="Enter number of winners"
        />
      </div>
      {/* Submit Button */}
      <div className="max-w-md w-full mx-auto px-3 pb-4 flex-shrink-0">
        <button
          onClick={handleSubmit}
          className="py-3 w-full text-lg bg-[#56920D] text-white rounded-lg hover:bg-[#3F9217] transition-colors"
        >
          {loading ? "Loading..." : "NEXT"}
        </button>
      </div>
    </div>
  );
};

export default CreateHostedGame;
